export const comparisonTable = {
  title: 'Features comparison',
  tableHeading: ['Feature', 'Exetel App v2.0', 'Exetel App v3.0'],
  tableHeadingMobile: ['Feature', 'v2.0', 'v3.0'],
  data: [
    {
      title: 'Exray',
      subtitle: 'Residential nbn customers only on One Plan 500/50',
      content: [
        {
          text: 'Check your internet health quickly and efficiently in-app',
          version_1: false,
          version_2: true,
        },
        {
          text: 'Determine if the problem is your connection or a planned outage',
          version_1: false,
          version_2: true,
        },
        {
          text: 'Advise on potential solutions and next steps',
          version_1: false,
          version_2: true,
        },
        {
          text: 'Easily schedule nbn technician appointments',
          version_1: false,
          version_2: true,
        },
      ],
    },
    {
      title: 'Progress Tracker',
      subtitle: 'Residential nbn customers only on One Plan 500/50',
      content: [
        {
          text: 'Follow progress of your orders',
          version_1: false,
          version_2: true,
        },
        {
          text: 'View your latest activity',
          version_1: false,
          version_2: true,
        },
        {
          text: 'Easily schedule or reschedule nbn technician appointments',
          version_1: false,
          version_2: true,
        },
        {
          text: 'A seamless and transparent setup experience from start to finish',
          version_1: false,
          version_2: true,
        },
      ],
    },
    {
      title: 'Self-manage',
      subtitle: '',
      content: [
        {
          text: 'Control your internet speed and oversee your plan',
          version_1: true,
          version_2: true,
        },
        {
          text: 'Easily recharge your mobile plan',
          version_1: true,
          version_2: true,
        },
        { text: 'Change your mobile plans', version_1: false, version_2: true },
        {
          text: 'Activate your eSIM in-app',
          version_1: false,
          version_2: true,
        },
        {
          text: 'New visual way to track your current and historical mobile data and usage',
          version_1: false,
          version_2: true,
        },
      ],
    },
    {
      title: 'Hibernate',
      subtitle: 'Residential nbn customers only on One Plan 500/50',
      content: [
        {
          text: 'Less speed, more savings—Hibernate and save a dollar a day.',
          version_1: false,
          version_2: true,
        },
        {
          text: 'Set your Hibernate period.',
          version_1: false,
          version_2: true,
        },
        {
          text: 'Lower your speed to a budget-friendly 12/1 Mbps—perfect for light use.',
          version_1: false,
          version_2: true,
        },
      ],
    },
    {
      title: 'Warp Speed',
      subtitle: 'Residential nbn customers only on One Plan 500/50',
      content: [
        {
          text: 'Blast your nbn internet speed to 1000/50 via the app for an additional $1 a day. Typical evening speed: 600/42.5 Mbps.',
          version_1: false,
          version_2: true,
        },
        {
          text: "Choose a Warp duration from 1 to 6 days or select 'Infinite' to stay in Warp Speed until you turn it off manually.",
          version_1: false,
          version_2: true,
        },
      ],
    },
    {
      title: 'My Speed Boost™',
      subtitle:
        'Residential nbn customers only, excluding Everyday 25/10, Lightspeed 500/50 and One Plan 500/50',
      content: [
        {
          text: 'Monitor your Speed Upgrade Days, and purchase more though the app',
          version_1: true,
          version_2: true,
        },
        {
          text: 'Schedule Speed Upgrade Days on the go',
          version_1: true,
          version_2: true,
        },
        {
          text: 'Enhanced design and functionality makes My Speed Boost even easier to use',
          version_1: false,
          version_2: true,
        },
      ],
    },
    {
      title: 'Enhanced security',
      subtitle: '',
      content: [
        {
          text: 'Passwordless login with Multi-Factor Authentication (MFA) for added convenience',
          version_1: false,
          version_2: true,
        },
        {
          text: 'Secure payments made in-app',
          version_1: false,
          version_2: true,
        },
      ],
    },
    {
      title: 'Streamlined \nbilling experience',
      subtitle: '',
      content: [
        {
          text: 'Easily view the latest bill',
          version_1: true,
          version_2: true,
        },
        { text: 'Make manual payments', version_1: false, version_2: true },
        {
          text: 'Update payment method options',
          version_1: true,
          version_2: true,
        },
      ],
    },
    {
      title: 'Moving Home \n(coming soon)',
      subtitle: 'Residential nbn customers only on One Plan 500/50',
      content: [
        {
          text: 'Move your service to your new premises in-app',
          version_1: false,
          version_2: true,
        },
      ],
    },
    {
      title: 'Native \nNotifications',
      subtitle: '',
      content: [
        {
          text: 'Stay up-to-date with all activities on your account',
          version_1: false,
          version_2: true,
        },
        {
          text: 'Get notified when there is a planned maintenance or outage in your area',
          version_1: false,
          version_2: true,
        },
        {
          text: 'Customise your notification preferences',
          version_1: false,
          version_2: true,
        },
      ],
    },
  ],
};
